import { TYPES } from '../../action-types/athena';
import { IAthena2Point0_State, IAction } from './model';

export const defaultState: IAthena2Point0_State = {
	materialCodeAdditionalAttributes: [],
	amendmentExceptions: [],
	athenaOptionalChargeRateRetrieval: [],
	athenaOptionalChargeRateRetrievalError: null,
	materialCodeAdditionalAttributesError: null,
	amendmentExceptionsError: null,
	adHocContractualRates: null,
	adHocContractualRatesError: null,
	chargeSplitRules: null,
	chargeSplitRulesError: null,

};

export const reducer = (state: IAthena2Point0_State = defaultState, action: IAction) => {
	switch (action.type) {
		case TYPES.FETCH_MATERIAL_CODE_ADDITIONAL_ATTRIBUTES.PENDING:
			return {
				...state,
				materialCodeAdditionalAttributes: [],
				materialCodeAdditionalAttributesError: null,
			};
		case TYPES.FETCH_MATERIAL_CODE_ADDITIONAL_ATTRIBUTES.FULFILLED:
			return {
				...state,
				materialCodeAdditionalAttributes: action.payload,
				materialCodeAdditionalAttributesError: null,
			};
		case TYPES.FETCH_MATERIAL_CODE_ADDITIONAL_ATTRIBUTES.REJECTED:
			return {
				...state,
				materialCodeAdditionalAttributesError: action.payload,
				materialCodeAdditionalAttributes: [],
			};
		case TYPES.FETCH_CHARGE_AMENDMENT_EXCEPTIONS.RESET_ERROR:
			return {
				...state,
				materialCodeAdditionalAttributesError: null,
				materialCodeAdditionalAttributes: [],
			};
		case TYPES.FETCH_ATHENA_OPTIONAL_CHARGE_RATE_RETRIEVAL.PENDING:
			return {
				...state,
				athenaOptionalChargeRateRetrieval: [],
				athenaOptionalChargeRateRetrievalError: null,
			};
		case TYPES.FETCH_ATHENA_OPTIONAL_CHARGE_RATE_RETRIEVAL.FULFILLED:
			return {
				...state,
				athenaOptionalChargeRateRetrieval: action.payload,
				athenaOptionalChargeRateRetrievalError: null,
			};
		case TYPES.FETCH_ATHENA_OPTIONAL_CHARGE_RATE_RETRIEVAL.REJECTED:
			return {
				...state,
				athenaOptionalChargeRateRetrievalError: action.payload,
				athenaOptionalChargeRateRetrieval: [],
			};
		case TYPES.FETCH_ATHENA_OPTIONAL_CHARGE_RATE_RETRIEVAL.RESET_ERROR:
			return {
				...state,
				athenaOptionalChargeRateRetrievalError: null,
				athenaOptionalChargeRateRetrieval: [],
			};

		case TYPES.FETCH_CHARGE_AMENDMENT_EXCEPTIONS.PENDING:
			return {
				...state,
				amendmentExceptions: [],
				amendmentExceptionsError: null,
			};
		case TYPES.FETCH_CHARGE_AMENDMENT_EXCEPTIONS.FULFILLED:
			return {
				...state,
				amendmentExceptions: action.payload,
				amendmentExceptionsError: null,
			};
		case TYPES.FETCH_CHARGE_AMENDMENT_EXCEPTIONS.REJECTED:
			return {
				...state,
				amendmentExceptionsError: action.payload,
				amendmentExceptions: [],
			};
		case TYPES.FETCH_CHARGE_AMENDMENT_EXCEPTIONS.RESET_ERROR:
			return {
				...state,
				amendmentExceptionsError: null,
				amendmentExceptions: [],
			};
		case TYPES.FETCH_ADHOC_CONTRACTUAL_RATES.PENDING:
			return {
				...state,
				adHocContractualRates: null,
				adHocContractualRatesError: null,
			};
		case TYPES.FETCH_ADHOC_CONTRACTUAL_RATES.FULFILLED:
			return {
				...state,
				adHocContractualRates: action.payload,
				adHocContractualRatesError: null,
			};
		case TYPES.FETCH_ADHOC_CONTRACTUAL_RATES.REJECTED:
			return {
				...state,
				adHocContractualRates: null,
				adHocContractualRatesError: action.payload,				
			};
		case TYPES.FETCH_ADHOC_CONTRACTUAL_RATES.RESET_ERROR:
			return {
				...state,
				adHocContractualRates: null,
				adHocContractualRatesError: null,
			};
		case TYPES.FETCH_CHARGE_SPLIT_RULES.PENDING:
			return {
				...state,
				chargeSplitRules: null,
				chargeSplitRulesError: null,
			};
		case TYPES.FETCH_CHARGE_SPLIT_RULES.FULFILLED:
			return {
				...state,
				chargeSplitRules: action.payload,
				chargeSplitRulesError: null,
			};
		case TYPES.FETCH_CHARGE_SPLIT_RULES.REJECTED:
			return {
				...state,
				chargeSplitRules: null,
				chargeSplitRulesError: action.payload,
			};
		default:
			return state;
	}
};